// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c8Af","placeholdersHeader":"styles_placeholdersHeader__2PwH5","editorStyle":"styles_editorStyle__2UCJy","placeholdersBox":"styles_placeholdersBox__1eMf_"};